// removed by extract-text-webpack-plugin
module.exports = {"container":"build_v16-container-7ZlxtAXUruw","overlay":"build_v16-overlay-el6LO2hbC88","wrapper":"build_v16-wrapper-48C3QGQebY2","content":"build_v16-content-ksWJG9wpcAK","close-button":"build_v16-close-button-Jp07mDNf2u"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/AuthenticationPopup/index.css
// module id = 246
// module chunks = 2